import {
    Component,
    Input,
    TemplateRef,
    ViewChild,
    ElementRef,
    forwardRef,
    Output,
    EventEmitter
} from '@angular/core';
import { ToolBarToolComponent } from '@progress/kendo-angular-toolbar';

export function outerWidth(element: any): number {
    let width = element.offsetWidth;
    const style = getComputedStyle(element);

    width += (parseFloat(style.marginLeft) || 0 + parseFloat(style.marginRight) || 0);
    return width;
}

@Component({
    providers: [{ provide: ToolBarToolComponent, useExisting: forwardRef(() => ToolBarSubscriptionComponent) }],
    selector: 'flow-runs-sub',
    template: `
        <ng-template #toolbarTemplate>
            <span #toolbarElement>
                <fa-icon icon="user-circle" title="subscription feature" style="margin-left:1px;"></fa-icon>                 
                <!-- <button kendoButton [icon]="'reload-sm'">
                     Get all runs (slow)
                     <fa-icon icon="user-circle" title="Get All Runs is a subscription feature" style="margin-left:1px;"></fa-icon>                 
                </button> -->
            </span>
        </ng-template>
    `,
    standalone: false
})
export class ToolBarSubscriptionComponent extends ToolBarToolComponent {
    @Input() public text: string;

    @ViewChild('toolbarTemplate', {static: true}) public toolbarTemplate: TemplateRef<any>;
    @ViewChild('toolbarElement', {static: true}) public toolbarElement: ElementRef;

    public get outerWidth(): number {
        if (this.toolbarElement) {
            return outerWidth(this.toolbarElement.nativeElement);
        }
    }

    greatFeedback(){

    }
}